import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import LinearProgress from '@material-ui/core/LinearProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { Framework } from '@flint/framework';
import { inject, observer } from 'mobx-react';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: theme.spacing(4),

    },
    paper: {
        width: '100%',
        height: "100%",
    },
    formTextField: {
        margin: theme.spacing(2, 0),
    },
    formControl: {
        width: "100%",
        margin: theme.spacing(2, 0),
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    formButton: {
        color: "#FFF",
        padding: "15px",
        margin: theme.spacing(2, 0),
        fontSize: "18px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "20px",
        background: "#222747",
        borderRadius: "3px",
        textTransform: "uppercase",
        transition: "background 0.25s",
        border: "2px solid #222747",
        "&:hover": {
            background: "none",
            color: "#222747",
        },
    },
    formTitle: {
        fontFamily: "Merriweather",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "28px",
        lineHeight: "90px",
        color: "#222747",
    },
}));

const EditUserForm = ({ AddAdminStore, AddAdminStoreStatus, GetUserStore, EditUserStore, EditUserStoreStatus }) => {

    const classes = useStyles();
    const [page, setPage] = React.useState("Add");
    const [addDialogOpen, setAddDialogOpen] = React.useState(false);
    const [editDialogOpen, setEditDialogOpen] = React.useState(false);
    const [users, setUsers] = React.useState({});
    const [errors, setErrors] = React.useState({});

    const handleChange = (event) => {
        const key = event.target.id;
        const val = event.target.value;
        setUsers(prevState => {
            return { ...prevState, [key]: val }
        })
    }


    const handleSwitchChange = (event) => {
        const key = event.target.name;
        setUsers(prevState => {
            return { ...prevState, [key]: !prevState[key] }
        })
        // if (key == 'isAdmin' && val == 'true') {
        //     setUsers(prevState => {
        //         return { ...prevState, ["endDate"]: null, ["startDate"]: null}
        //     })
        // }
    }

    const handleStartDateChange = (date) => {
        setUsers(prevState => {
            return { ...prevState, 'startDate': date }
        })
    };

    const handleEndDateChange = (date) => {
        setUsers(prevState => {
            return { ...prevState, 'endDate': date }
        })
    };

    const validate = () => {
        let temp = {}
        temp.name = users.name ? "" : "Name is required for Admin.";
        temp.email = users.email ? "" : "Email is required for Admin.";
        const validEmail = new RegExp('^[a-zA-Z0-9]+@wiley.com$');
        const validQAEmail = new RegExp('^[a-zA-Z0-9]+@wileyqa.com$');
        temp.email = validEmail.test(users.email) || validQAEmail.test(users.email) ? "" : "Only Wiley Users can be admin."
        temp.startDate = users.startDate ? "" : "Start Date is required for Admin.";
        temp.endDate = users.endDate ? "" : "End Date is required for Admin.";
        setErrors({ ...temp });
        return Object.values(temp).every(x => x === "");
    }

    const handleAddAdmin = () => {
        if (validate()) {
            Framework.sendEvent("ADDING_ADMIN_DATA", users);
            setAddDialogOpen(true);
        }
    }

    const handleEditUser = () => {
        Framework.sendEvent("EDITING_USER_DATA", users);
        setEditDialogOpen(true);
    }

    const handleGoBack = () => {
        Framework.redirect('/users');
    }

    const handleAddDialogClose = () => {
        setAddDialogOpen(false);
        if (!AddAdminStoreStatus.isError)
            Framework.redirect('/users');
    }


    const handleEditDialogClose = () => {
        setEditDialogOpen(false);
        if (!EditUserStoreStatus.isError)
            Framework.redirect('/users');
    }

    const handleEditDialogBack = () => {
        setEditDialogOpen(false);
    }

    const handleAddDialogBack = () => {
        setAddDialogOpen(false);
    }

    React.useEffect(() => {
        document.title = page === "Add" ? "Add Admin" : "Edit User";
        if (page === "Edit") {
            Framework.sendEvent("FETCHING_USER_DATA", `${window.location.pathname.split("/")[2]}`);
            setUsers(GetUserStore);
        }
    }, [page])

    React.useEffect(() => {
        const href = window.location.href.split("/")[3].split("-")[0];
        setPage(href.charAt(0).toUpperCase() + href.slice(1));
    }, [])

    return (
        <>
            {AddAdminStoreStatus.isPending ? <LinearProgress color="secondary" /> : <Dialog
                open={addDialogOpen}
                onClose={handleAddDialogClose}
                aria-labelledby="sync-dialog-title"
                aria-describedby="sync-dialog-description"
            >
                <DialogTitle id="sync-dialog-title">Add Administrator</DialogTitle>
                <DialogContent>
                    <DialogContentText id="sync-dialog-description">
                        {AddAdminStore.res}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {AddAdminStore.stat === "SUCCESS" && <Button variant="contained" color="primary" target="_blank" href="https://wiley.service-now.com/service_gateway?id=sc_cat_item&sys_id=0e427b12dbd517009fe8776b8c9619f1&sysparm_app=97e44da3db05978063b6d7795e9619cc">ServiceNow</Button>}
                    <div style={{ flex: '1 0 0' }} />
                    {AddAdminStore.stat === "SUCCESS" ? <Button onClick={handleAddDialogClose} color="primary">
                        OK
                    </Button> : <Button onClick={handleAddDialogBack} color="primary">
                        OK
                    </Button>}
                </DialogActions>
            </Dialog>}
            {EditUserStoreStatus.isPending ? <LinearProgress color="secondary" /> : <Dialog
                open={editDialogOpen}
                onClose={handleEditDialogClose}
                aria-labelledby="sync-dialog-title"
                aria-describedby="sync-dialog-description"
            >
                <DialogTitle id="sync-dialog-title">Edit User</DialogTitle>
                <DialogContent>
                    <DialogContentText id="sync-dialog-description">
                        {EditUserStore.res}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {EditUserStore.stat === "SUCCESS" && <Button variant="contained" color="primary" target="_blank" href="https://wiley.service-now.com/service_gateway?id=sc_cat_item&sys_id=0e427b12dbd517009fe8776b8c9619f1&sysparm_app=97e44da3db05978063b6d7795e9619cc">ServiceNow</Button>}
                    <div style={{ flex: '1 0 0' }} />
                    {EditUserStore.stat === "SUCCESS" ? <Button onClick={handleEditDialogClose} color="primary">
                        OK
                    </Button> : <Button onClick={handleEditDialogBack} color="primary">
                        OK
                    </Button>}
                </DialogActions>
            </Dialog>}
            <div className={classes.root}>
                <Grid container spacing={3} justify="center">
                    <Grid item xs={12} sm={10} md={8} lg={6}>
                        <Paper className={classes.paper}>
                            <form className={classes.root}>
                                {page === "Edit" ? <Typography className={classes.formTitle} variant="h1" id="tableTitle" component="div">Edit User</Typography> : <Typography className={classes.formTitle} variant="h1" id="tableTitle" component="div">Add Admin</Typography>}
                                {page === "Edit" && <TextField className={classes.formTextField} id="id" label="id" name="id" value={users.id ? users.id : ""} disabled variant="outlined" fullWidth onChange={handleChange} />}
                                <TextField className={classes.formTextField} id="name" label="Name" name="name" value={users.name ? users.name : ""} disabled={page === "Add" ? false : true} variant="outlined" fullWidth onChange={handleChange} {...(errors.name && { error: true, helperText: errors.name })} />
                                {page === "Edit" && <TextField className={classes.formTextField} id="status" label="status" name="status" value={users.status ? users.status : ""} disabled variant="outlined" fullWidth onChange={handleChange} />}
                                <TextField className={classes.formTextField} id="email" label="Email" name="email" value={users.email ? users.email : ""} disabled={page === "Add" ? false : true} variant="outlined" fullWidth onChange={handleChange} {...(errors.email && { error: true, helperText: errors.email })} />
                                {page === "Edit" ? <FormControlLabel className={classes.formControlLabel} control={<Switch checked={users.isAdmin ? true : false} name="isAdmin" value={users.isAdmin ? true : false} onChange={handleSwitchChange} />} label="Is Admin" /> :
                                    <FormControlLabel className={classes.formControlLabel} control={<Switch checked name="isAdmin" {...users.isAdmin = true} />} label="Is Admin" />
                                }
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <Grid container justify="space-around">
                                        <KeyboardDatePicker
                                            disableToolbar
                                            variant="inline"
                                            format="MM/DD/yyyy"
                                            id="start-date"
                                            label="Start Date"
                                            value={users.startDate ? users.startDate : null}
                                            autoOk={true}
                                            onChange={handleStartDateChange}
                                            {...(errors.startDate && { error: true, helperText: errors.startDate })}
                                        />
                                        <KeyboardDatePicker
                                            disableToolbar
                                            label="End Date"
                                            variant="inline"
                                            format="MM/DD/yyyy"
                                            value={users.endDate ? users.endDate : null}
                                            autoOk={true}
                                            onChange={date => handleEndDateChange(date)}
                                            minDate={users.startDate}
                                            {...(errors.endDate && { error: true, helperText: errors.endDate })}
                                        />
                                    </Grid>
                                </MuiPickersUtilsProvider>
                                {
                                    <Grid container direction="row" justify="space-between" alignItems="center">
                                        <Button className={classes.formButton} variant="contained" color="primary"
                                            onClick={handleGoBack}>
                                            Go Back
                                            </Button>
                                        {page === "Edit" ? <Button className={classes.formButton} variant="contained" color="primary"
                                            startIcon={<SaveIcon />}
                                            onClick={handleEditUser}>
                                            Update User
                                            </Button> : <Button className={classes.formButton} variant="contained" color="primary"
                                            startIcon={<SaveIcon />}
                                            onClick={handleAddAdmin}>
                                            Add Admin
                                            </Button>}
                                    </Grid>
                                }

                            </form>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default inject('AddAdminStore', 'AddAdminStoreStatus', 'GetUserStore', 'EditUserStore', 'EditUserStoreStatus')(observer(EditUserForm));